<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">ADMINS</h5>
                <div
                  class="flex-shrink-0 me-2"
                  v-if="ldata != null && ldata.role == 'superadmin'"
                >
                  <button
                    type="button"
                    class="btn btn-success add-btn"
                    @click="add('/add_admin')"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> Add Admin
                  </button>
                </div>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="expSetNow()"
                    fdprocessedid="1yahzs"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-5 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        v-model="search_key"
                        @input="fetchList(1)"
                        @keydown.enter.prevent
                        class="form-control search"
                        placeholder="Enter Name or Email "
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div class="col-xxl-2 col-sm-4">
                    <div>
                      <select
                        class="form-control"
                        v-model="search_role"
                        v-on:change="fetchList(1)"
                        name="choices-single-default"
                        id="idStatus"
                      >
                        <option value="" selected>Filters</option>
                        <template
                          v-for="(role, index) in roleOptions"
                          :key="index"
                        >
                          <option :value="role.value">{{ role.label }}</option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div>
                <div class="table-responsive table-card mb-1 mt-4">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="ldata"
                      :headers="headers"
                      :tableData="formattedAdmin"
                      @edit="updateAdmin"
                      @delete="openDeleteDialog"
                      @update-status="updateStatus"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="admin.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="admin.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="admin.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteDialog
        title="Delete Admin ?"
        ref="deleteDialog"
        @confirm="deleteAdmin"
      />
      <ToastNotification ref="toast" />
      <loaderLoading v-if="overallLoading" />
    </div>
  </div>
</template>

<script>
import { getAllAdmins, deleteAdmin, getAdminById } from "@/apis/admin";
import listMixin from "@/mixins/listMixin";
import { adminFilterOptions } from "@/constants/filter";
import { adminHeaders } from "@/constants/headers";

export default {
  name: "AdminList",

  mixins: [listMixin],

  data() {
    return {
      admin: [],

      search_key: "",
      search_role: "",

      headers: adminHeaders,
      roleOptions: adminFilterOptions,
    };
  },

  methods: {
    expSetNow() {
      const fields = ["name", "email", "created_at", "mobile", "role"];
      this.$exportCsv(this.formattedAdmin, "Admin.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getAllAdmins, {
        search_key: this.search_key,
        search_role: this.search_role,
      });

      this.admin = response.data;

      this.stopLoading();
    },

    async deleteAdmin(admin) {
      await this.delete(deleteAdmin, admin.id);
    },

    async updateAdmin(admin) {
      await this.update(getAdminById, admin.id, "/add_admin");
    },
  },

  computed: {
    formattedAdmin() {
      return this.admin?.map((admin) => ({
        id: admin.id,
        name: admin.name || "N/A",
        created_at: admin.created_at
          ? new Date(admin.created_at).toLocaleString()
          : "N/A",
        mobile: admin.phone_number || "N/A",
        email: admin.email || "N/A",
        role: admin.role || "N/A",
        status: admin.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
